import React from "react";

const UxUi = () => {
  return (
    <div className="skills_content">
      <h3 className="skills_title">User Experience Design</h3>

      <div className="skills_box">
        <div className="skills_group">
          <div className="skills_data">
            <i className="bx bx-badge-check"></i>

            <div>
              <h3 className="skills_name">Figma</h3>
            </div>
          </div>

          <div className="skills_data">
            <i className="bx bx-badge-check"></i>

            <div>
              <h3 className="skills_name">Hand Sketching</h3>
            </div>
          </div>
        </div>

        <div className="skills_group">
          <div className="skills_data">
            <i className="bx bx-badge-check"></i>

            <div>
              <h3 className="skills_name">Wireframes</h3>
            </div>
          </div>

          <div className="skills_data">
            <i className="bx bx-badge-check"></i>

            <div>
              <h3 className="skills_name">High fidelity Prototypes</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UxUi;
